export var composeName = function composeName(name) {
  var r = function r(n) {
    if (typeof n === 'string') {
      return composeName(name + n);
    } else if (typeof n === 'function') {
      return composeName(name + n());
    } else {
      return name;
    }
  };

  return r;
};